import type { Session } from '@supabase/supabase-js';

import { useWizardState } from './useWizardState';
import { Step1Welcome } from './Step1Welcome';
import { Step2Business } from './Step2Business';
import { Step3Locale } from './Step3Locale';
import { Step4Confirm } from './Step4Confirm';

interface Props {
  session: Session;
}

function defaultFullNameFor(session: Session): string {
  const meta = session.user.user_metadata as { full_name?: unknown } | undefined;
  if (meta && typeof meta.full_name === 'string' && meta.full_name.trim().length > 0) {
    return meta.full_name.trim();
  }
  const email = session.user.email ?? '';
  return email.split('@')[0] ?? '';
}

export function WelcomeWizard({ session }: Props) {
  const step = useWizardState((s) => s.step);
  const defaultFullName = defaultFullNameFor(session);

  if (step === 0) return <Step1Welcome defaultFullName={defaultFullName} />;
  if (step === 1) return <Step2Business />;
  if (step === 2) return <Step3Locale />;
  return <Step4Confirm />;
}
